/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CookiesService {

    /**
     * Refresh an authentication cookie
     * @returns any Successfully refreshed authentication cookie
     * @throws ApiError
     */
    public static refreshAuthCookie(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/auth/cookies/refresh',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
